namespace Matrix.Data {
    export interface EditSMPrimarySecurityOverridenRequest extends Serenity.ServiceRequest {
        RowId?: number;
        IsChecked?: boolean;
    }
}
